import React from "react";
import { Colors } from "../constants/colors";
import { Font } from "../constants/fonts";

type ButtonProps = {
  text?: string;
  backgroundColor?: string;
  color?: string;
  onClick?: () => void;
  width?: string | number;
};

export const Button: React.FC<ButtonProps> = ({
  text = '',
  backgroundColor = Colors.primary,
  color = Colors.white,
  onClick,
  width = 0
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        ...styles.button,
        backgroundColor,
        color,
        width: width ? width : 'auto'
      }}
    >
      {text}
    </button>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  button: {
    padding: '20px 30px',
    borderRadius: "20px",
    border: "none",
    cursor: "pointer",
    fontSize: Font.button.fontSize,
    fontWeight: Font.button.fontWeight,
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.25)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
  },
};
